import { Store } from 'vuex';
import { RootState } from '@/ui/store/types/root-module.types';
import serviceProvider from '@/services/service-provider';
import { FormLike, ToastyLike } from '@/ui/types/components.types';
import { iProfile } from '@/entities/profile/profile.types';
import Profile from '@/entities/profile/profile';
import { GetTextFunction } from '@/ui/types/i18n.types';
import { ProfileEditVariables } from './use-profile-edit-variables';

export type ProfileEditFunctionParams = {
  $store: Store<RootState>;
  $refs: { [key: string]: Vue | Element | Vue[] | Element[] };
  profileEditVariables: ProfileEditVariables;
  getText: GetTextFunction;
};

const MODULE = 'ProfileEdit';

export default function useProfileEditFunctions({
  $store,
  $refs,
  profileEditVariables,
  getText,
}: ProfileEditFunctionParams) {
  const {
    profilePic,
    profileCover,
    gamertag,
    loading,
    toastyMessage,
    toastyColor,
  } = profileEditVariables;

  async function submit() {
    loading.value = true;
    // This is a hack to let typescript know that child has validate method
    const form = $refs.form as Vue & FormLike;
    const toasty = $refs.toasty as Vue & ToastyLike;
    form.validate();

    const { valid } = form;

    if (!valid) {
      loading.value = false;
      return;
    }

    const user: iProfile = $store.getters['profile/profile'];
    let pPic: null | string = null;
    let pCover: null | string = null;

    if (profilePic.value) {
      const upload = await serviceProvider.profilePic.upload(user.id, profilePic.value);
      pPic = upload.fullPath;
    }

    if (profileCover.value) {
      const upload = await serviceProvider.profileCover.upload(user.id, profileCover.value);
      pCover = upload.fullPath;
    }

    const newProfile = new Profile(
      user.id,
      gamertag.value,
      pPic || user.profilePic,
      pCover || user.profileCover,
    );

    try {
      await serviceProvider.user.updateUser(newProfile);
    } catch (error) {
      toastyColor.value = 'error';
      toastyMessage.value = getText(MODULE, 'errors', 'editProfile');
      toasty.show();
      return;
    }

    toastyColor.value = 'success';
    toastyMessage.value = getText(MODULE, 'messages', 'editProfileSuccess');
    toasty.show();

    await $store.dispatch('profile/updateProfileAttribtues', newProfile);
    loading.value = false;
  }

  function cancel() {
    // TODO
  }

  async function onProfilePicSelected(file: File) {
    profilePic.value = file;
  }

  function onProfileCoverSelected(file: File) {
    profileCover.value = file;
  }

  return {
    submit,
    cancel,
    onProfilePicSelected,
    onProfileCoverSelected,
  };
}
